import { Injectable } from "@angular/core";
@Injectable({

  providedIn: "root",

})

export class ApiConfiguration {

  // configAddLanguage: any;

  // configGetLanguages(configGetLanguages: any) {

  //   throw new Error('Method not implemented.');

  // }


  // Staging
  baseUrl = 'https://misautomationapi.misautomation.bigcityvoucher.co.in/v1/';

  login = this.baseUrl + "login/login?program_id=1";

  rejectedReasons = this.baseUrl + 'appuser/reject-reasons'

  // Skus

  addSkus = this.baseUrl + "skus/add-skus";

  getBrands = this.baseUrl + "skus/list-skus-master";

  editSkus = this.baseUrl + "skus/edit-skus";


  getbranchForFilter = this.baseUrl + 'skus/get-branches';


  // campaign

  createCampaign = this.baseUrl + 'skus/create-campaign';

  brandList = this.baseUrl + 'skus/get-brands';

  downloadusers = this.baseUrl + 'skus/campaign-users-list';

  uploadusers = this.baseUrl + 'skus/campaign-approved-users';
  campaignList = this.baseUrl + 'skus/get-campaign-list';
  downloadCampignTargets = this.baseUrl + 'target/retailers-target-excel';

  // PackConfig

  getProgramList = this.baseUrl + "skus/list-program?name=";

  getChildProgramList = this.baseUrl + "skus/list-child-program";

  getParentPrograms = this.baseUrl + "skus/list-program?master_construct=1";

  addProgram = this.baseUrl + "skus/add-program";

  getPack = this.baseUrl + "skus/list-pack-config";

  getGeneratedCoupon = this.baseUrl + "skus/list-coupon-request";

  addPacks = this.baseUrl + "skus/add-pack-config";

  editPack = this.baseUrl + "skus/edit-pack-config";

  // User

  uploadExcelsheet = this.baseUrl + "registration/insertuser";

  getUsersdetail = this.baseUrl + 'registration/readuser';

  serchByname = this.baseUrl + 'registration/readuser?search_by=';

  downloadUserList = this.baseUrl + 'registration/user-details'
  updateUserNumber = this.baseUrl + 'registration/update-user-num'

  //Assign Coupons

  assignCoupons = this.baseUrl + "skus/coupon-assignment";

  couponRequest = this.baseUrl + "skus/generate-coupon-request";

  generateCoupon = this.baseUrl + "coupon/genereatecoupons";

  getRolls = this.baseUrl + 'user/get-roles';

  passRollid = this.baseUrl + "registration/readuser?role_id=";

  wdAssignCoupons = this.baseUrl + 'target/wd-assignment-list'

  //generate codes



  codeRequest = this.baseUrl + 'skus/generate-reg-coupon';

  generateCode = this.baseUrl + 'skus/generate-codes';

  assignCode = this.baseUrl + 'skus/registration-coupon';

  ListOfCodes = this.baseUrl + 'skus/list-code-request';


  //Inventory Request

  listOfinventory = this.baseUrl + 'skus/list-inventory-request';

  approveRequest = this.baseUrl + 'skus/approve-wd-request';

  rejectRequest = this.baseUrl + 'appuser/reject-request';

  uploadInventory = this.baseUrl + 'skus/upload-inventory-request';


  //Targets

  uploadTarget = this.baseUrl + 'target/upload-targets'

  getTragets = this.baseUrl + 'target/get-target-files'

  getTragetMaster = this.baseUrl + 'target/get-target-master'

  userValidate = this.baseUrl + 'registration/show-users'

  insertUpdatedUsers = this.baseUrl + 'registration/insert-user-approval'

  approveReject = this.baseUrl + 'registration/validate-users'


  //BranD Master

  getBrandList = this.baseUrl + 'brand/list-brand';
  editBrand = this.baseUrl + 'brand/edit-brand';
  addBrands = this.baseUrl + 'brand/add-brand';
  branch = this.baseUrl + 'report/list-branch';
  marketRegions = this.baseUrl + 'report/get-region'
  listCampaign = this.baseUrl + 'admin/list-campaign';
  listConstrct = this.baseUrl + 'admin/list-construct';
  payoutDetails = this.baseUrl + 'admin/payout-details';
  usersAndCampaigns = this.baseUrl + 'admin/users-and-campaigns';
  userPerformance = this.baseUrl + 'admin/user-performance';
  paymentModes = this.baseUrl + 'admin/payment-modes';
  payoutStatus = this.baseUrl + 'admin/payout-status';


  //automation

  getProgram=this.baseUrl + 'mis-automation/get-programs'
  getFunctionality=this.baseUrl + 'mis-automation/get-functionalities'
  getRules=this.baseUrl + 'mis-automation/get-rules'
  getSystemFields=this.baseUrl + 'mis-automation/get-system-fields'
  saveAutomation=this.baseUrl + 'mis-automation/save-automation'
  getAutomation=this.baseUrl + 'mis-automation/get-automation'





}

export interface ApiConfigurationInterface { }